var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-image-map",
      on: {
        mousedown: _vm.selectShape,
      },
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.initCurrentData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _c("img", {
                    ref: "original_img",
                    staticClass: "cw-image-map-original-img",
                    attrs: {
                      src: _vm.currentUrl,
                    },
                    on: {
                      load: _vm.buildCanvas,
                    },
                  }),
                  _vm._v(" "),
                  _c("canvas", {
                    ref: "canvas",
                    staticClass: "cw-image-map-canvas",
                  }),
                  _vm._v(" "),
                  _c("img", {
                    ref: "image_from_canvas",
                    staticClass: "cw-image-from-canvas",
                    attrs: {
                      src: _vm.image_from_canvas,
                      usemap: "#" + _vm.map_name,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "map",
                    {
                      ref: "map",
                      attrs: {
                        name: _vm.map_name,
                      },
                    },
                    _vm._l(_vm.areas, function (area) {
                      return _c("area", {
                        key: area.id,
                        attrs: {
                          id: area.id,
                          shape: area.shape,
                          coords: area.coords,
                          title: area.title,
                          href: area.external_target,
                          target: area.link_target,
                        },
                        on: {
                          click: function click($event) {
                            if (area.target_type === "internal") {
                              _vm.areaLink(area.internal_target)
                            }
                          },
                        },
                      })
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.showEditMode &&
                  _vm.viewMode === "edit" &&
                  _vm.currentShapes.length > 0
                    ? _c(
                        "div",
                        {
                          ref: "draggableShapeWrapper",
                          staticClass: "cw-draggable-shapes-wrapper",
                        },
                        _vm._l(_vm.currentShapes, function (shape, index) {
                          return _c(
                            "vue-resizeable",
                            {
                              key: index,
                              ref: "resizableAreaComponents",
                              refInFor: true,
                              staticStyle: {
                                position: "absolute",
                              },
                              attrs: {
                                index: index,
                                fitParent: true,
                                dragSelector: _vm.dragSelector,
                                active: _vm.handlers,
                                left: _vm.getShapeOffsetLeft(shape),
                                top: _vm.getShapeOffsetTop(shape),
                                width: _vm.getShapeWidth(shape),
                                height: _vm.getShapeHeight(shape),
                              },
                              on: {
                                "resize:start": _vm.dragStartHandler,
                                "resize:end": _vm.endDraggingShape,
                                "drag:start": _vm.dragStartHandler,
                                "drag:end": _vm.endDraggingShape,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "cw-draggable-area",
                                  style: {
                                    backgroundColor: _vm.getColorRGBA(
                                      shape.data.color
                                    ),
                                    color: shape.data.textcolor
                                      ? _vm.getColorRGBA(shape.data.textcolor)
                                      : "",
                                    borderRadius:
                                      _vm.getShapeBorderRadius(shape),
                                    border: _vm.getShapeBorder(shape),
                                    cursor:
                                      _vm.selectedShapeIndex !== false
                                        ? "grabbing"
                                        : "",
                                  },
                                  on: {
                                    click: function click($event) {
                                      return _vm.followLink(index)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(shape.data.text) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c(
                            "label",
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$gettext("Bilddatei")) +
                                  "\n                    "
                              ),
                              _c("studip-file-chooser", {
                                attrs: {
                                  selectable: "file",
                                  courseId: _vm.studipContext.id,
                                  userId: _vm.userId,
                                  isImage: true,
                                  excludedCourseFolderTypes:
                                    _vm.excludedCourseFolderTypes,
                                },
                                model: {
                                  value: _vm.currentFileId,
                                  callback: function callback($$v) {
                                    _vm.currentFileId = $$v
                                  },
                                  expression: "currentFileId",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("label", [
                            _c(
                              "a",
                              {
                                staticClass: "button add",
                                on: {
                                  click: function click($event) {
                                    return _vm.addShape("arc")
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$gettext("Kreis hinzufügen")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "button add",
                                on: {
                                  click: function click($event) {
                                    return _vm.addShape("ellipse")
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$gettext("Oval hinzufügen")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "button add",
                                on: {
                                  click: function click($event) {
                                    return _vm.addShape("rect")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$gettext("Rechteck hinzufügen"))
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.currentShapes.length > 0
                            ? _c(
                                "courseware-tabs",
                                _vm._l(
                                  _vm.currentShapes,
                                  function (shape, index) {
                                    return _c(
                                      "courseware-tab",
                                      {
                                        key: index,
                                        attrs: {
                                          index: index,
                                          name: shape.title ? shape.title : "",
                                          icon:
                                            shape.title === ""
                                              ? "link-extern"
                                              : "",
                                          selected: index === 0,
                                        },
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass: "col-2",
                                          },
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(_vm.$gettext("Farbe")) +
                                                "\n                            "
                                            ),
                                            _c("studip-select", {
                                              attrs: {
                                                options: _vm.colors,
                                                label: "name",
                                                reduce: function reduce(color) {
                                                  return color.class
                                                },
                                                clearable: false,
                                              },
                                              on: {
                                                input: _vm.drawScreen,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "open-indicator",
                                                    fn: function fn(
                                                      selectAttributes
                                                    ) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          _vm._b(
                                                            {},
                                                            "span",
                                                            selectAttributes,
                                                            false
                                                          ),
                                                          [
                                                            _c("studip-icon", {
                                                              attrs: {
                                                                shape:
                                                                  "arr_1down",
                                                                size: 10,
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "no-options",
                                                    fn: function fn() {
                                                      return [
                                                        _vm._v(
                                                          "\n                                    " +
                                                            _vm._s(
                                                              _vm.$gettext(
                                                                "Es steht keine Auswahl zur Verfügung."
                                                              )
                                                            ) +
                                                            "\n                                "
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                  {
                                                    key: "selected-option",
                                                    fn: function fn(option) {
                                                      return [
                                                        _c("span", {
                                                          staticClass:
                                                            "vs__option-color",
                                                          style: {
                                                            "background-color":
                                                              option.rgba,
                                                          },
                                                        }),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(option.name)
                                                          ),
                                                        ]),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "option",
                                                    fn: function fn(option) {
                                                      return [
                                                        _c("span", {
                                                          staticClass:
                                                            "vs__option-color",
                                                          style: {
                                                            "background-color":
                                                              option.rgba,
                                                          },
                                                        }),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(option.name)
                                                          ),
                                                        ]),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                              model: {
                                                value: shape.data.color,
                                                callback: function callback(
                                                  $$v
                                                ) {
                                                  _vm.$set(
                                                    shape.data,
                                                    "color",
                                                    $$v
                                                  )
                                                },
                                                expression: "shape.data.color",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "col-2",
                                          },
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  _vm.$gettext("Textfarbe")
                                                ) +
                                                "\n                            "
                                            ),
                                            _c("studip-select", {
                                              attrs: {
                                                options: _vm.colors,
                                                label: "name",
                                                reduce: function reduce(color) {
                                                  return color.class
                                                },
                                                clearable: false,
                                              },
                                              on: {
                                                input: _vm.drawScreen,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "open-indicator",
                                                    fn: function fn(
                                                      selectAttributes
                                                    ) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          _vm._b(
                                                            {},
                                                            "span",
                                                            selectAttributes,
                                                            false
                                                          ),
                                                          [
                                                            _c("studip-icon", {
                                                              attrs: {
                                                                shape:
                                                                  "arr_1down",
                                                                size: 10,
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "no-options",
                                                    fn: function fn() {
                                                      return [
                                                        _vm._v(
                                                          "\n                                    " +
                                                            _vm._s(
                                                              _vm.$gettext(
                                                                "Es steht keine Auswahl zur Verfügung."
                                                              )
                                                            ) +
                                                            "\n                                "
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                  {
                                                    key: "selected-option",
                                                    fn: function fn(_ref) {
                                                      var name = _ref.name,
                                                        rgba = _ref.rgba
                                                      return [
                                                        _c("span", {
                                                          staticClass:
                                                            "vs__option-color",
                                                          style: {
                                                            "background-color":
                                                              rgba,
                                                          },
                                                        }),
                                                        _c("span", [
                                                          _vm._v(_vm._s(name)),
                                                        ]),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "option",
                                                    fn: function fn(_ref2) {
                                                      var name = _ref2.name,
                                                        rgba = _ref2.rgba
                                                      return [
                                                        _c("span", {
                                                          staticClass:
                                                            "vs__option-color",
                                                          style: {
                                                            "background-color":
                                                              rgba,
                                                          },
                                                        }),
                                                        _c("span", [
                                                          _vm._v(_vm._s(name)),
                                                        ]),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                              model: {
                                                value: shape.data.textcolor,
                                                callback: function callback(
                                                  $$v
                                                ) {
                                                  _vm.$set(
                                                    shape.data,
                                                    "textcolor",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "shape.data.textcolor",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(" "),
                                        shape.type === "arc"
                                          ? [
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "col-1",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                X\n                                "
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          shape.data.centerX,
                                                        expression:
                                                          "shape.data.centerX",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "number",
                                                    },
                                                    domProps: {
                                                      value: shape.data.centerX,
                                                    },
                                                    on: {
                                                      change: _vm.drawScreen,
                                                      input: function input(
                                                        $event
                                                      ) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          shape.data,
                                                          "centerX",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "col-1",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                Y\n                                "
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          shape.data.centerY,
                                                        expression:
                                                          "shape.data.centerY",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "number",
                                                    },
                                                    domProps: {
                                                      value: shape.data.centerY,
                                                    },
                                                    on: {
                                                      change: _vm.drawScreen,
                                                      input: function input(
                                                        $event
                                                      ) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          shape.data,
                                                          "centerY",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "col-1",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                " +
                                                      _vm._s(
                                                        _vm.$gettext("Radius")
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          shape.data.radius,
                                                        expression:
                                                          "shape.data.radius",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "number",
                                                    },
                                                    domProps: {
                                                      value: shape.data.radius,
                                                    },
                                                    on: {
                                                      change: _vm.drawScreen,
                                                      input: function input(
                                                        $event
                                                      ) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          shape.data,
                                                          "radius",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        shape.type === "rect"
                                          ? [
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "col-1",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                X\n                                "
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: shape.data.X,
                                                        expression:
                                                          "shape.data.X",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "number",
                                                    },
                                                    domProps: {
                                                      value: shape.data.X,
                                                    },
                                                    on: {
                                                      change: _vm.drawScreen,
                                                      input: function input(
                                                        $event
                                                      ) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          shape.data,
                                                          "X",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "col-1",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                Y\n                                "
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: shape.data.Y,
                                                        expression:
                                                          "shape.data.Y",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "number",
                                                    },
                                                    domProps: {
                                                      value: shape.data.Y,
                                                    },
                                                    on: {
                                                      change: _vm.drawScreen,
                                                      input: function input(
                                                        $event
                                                      ) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          shape.data,
                                                          "Y",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "col-1",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                " +
                                                      _vm._s(
                                                        _vm.$gettext("Höhe")
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          shape.data.height,
                                                        expression:
                                                          "shape.data.height",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "number",
                                                    },
                                                    domProps: {
                                                      value: shape.data.height,
                                                    },
                                                    on: {
                                                      change: _vm.drawScreen,
                                                      input: function input(
                                                        $event
                                                      ) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          shape.data,
                                                          "height",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "col-1",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                " +
                                                      _vm._s(
                                                        _vm.$gettext("Breite")
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: shape.data.width,
                                                        expression:
                                                          "shape.data.width",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "number",
                                                    },
                                                    domProps: {
                                                      value: shape.data.width,
                                                    },
                                                    on: {
                                                      change: _vm.drawScreen,
                                                      input: function input(
                                                        $event
                                                      ) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          shape.data,
                                                          "width",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        shape.type === "ellipse"
                                          ? [
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "col-1",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                X\n                                "
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: shape.data.X,
                                                        expression:
                                                          "shape.data.X",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "number",
                                                    },
                                                    domProps: {
                                                      value: shape.data.X,
                                                    },
                                                    on: {
                                                      change: _vm.drawScreen,
                                                      input: function input(
                                                        $event
                                                      ) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          shape.data,
                                                          "X",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "col-1",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                Y\n                                "
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: shape.data.Y,
                                                        expression:
                                                          "shape.data.Y",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "number",
                                                    },
                                                    domProps: {
                                                      value: shape.data.Y,
                                                    },
                                                    on: {
                                                      change: _vm.drawScreen,
                                                      input: function input(
                                                        $event
                                                      ) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          shape.data,
                                                          "Y",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "col-1",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                " +
                                                      _vm._s(
                                                        _vm.$gettext("Radius")
                                                      ) +
                                                      " X\n                                "
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          shape.data.radiusX,
                                                        expression:
                                                          "shape.data.radiusX",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "number",
                                                    },
                                                    domProps: {
                                                      value: shape.data.radiusX,
                                                    },
                                                    on: {
                                                      change: _vm.drawScreen,
                                                      input: function input(
                                                        $event
                                                      ) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          shape.data,
                                                          "radiusX",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "col-1",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                " +
                                                      _vm._s(
                                                        _vm.$gettext("Radius")
                                                      ) +
                                                      " Y\n                                "
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          shape.data.radiusY,
                                                        expression:
                                                          "shape.data.radiusY",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "number",
                                                    },
                                                    domProps: {
                                                      value: shape.data.radiusY,
                                                    },
                                                    on: {
                                                      change: _vm.drawScreen,
                                                      input: function input(
                                                        $event
                                                      ) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          shape.data,
                                                          "radiusY",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "col-4",
                                          },
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  _vm.$gettext("Bezeichnung")
                                                ) +
                                                "\n                            "
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: shape.title,
                                                  expression: "shape.title",
                                                },
                                              ],
                                              attrs: {
                                                type: "text",
                                              },
                                              domProps: {
                                                value: shape.title,
                                              },
                                              on: {
                                                input: function input($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    shape,
                                                    "title",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "col-4",
                                          },
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  _vm.$gettext("Beschriftung")
                                                ) +
                                                "\n                            "
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: shape.data.text,
                                                  expression: "shape.data.text",
                                                },
                                              ],
                                              attrs: {
                                                type: "text",
                                              },
                                              domProps: {
                                                value: shape.data.text,
                                              },
                                              on: {
                                                change: _vm.drawScreen,
                                                input: function input($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    shape.data,
                                                    "text",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "col-2",
                                          },
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  _vm.$gettext("Art des Links")
                                                ) +
                                                "\n                            "
                                            ),
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: shape.link_type,
                                                    expression:
                                                      "shape.link_type",
                                                  },
                                                ],
                                                on: {
                                                  change: function change(
                                                    $event
                                                  ) {
                                                    var $$selectedVal =
                                                      Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function (o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function (o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                    _vm.$set(
                                                      shape,
                                                      "link_type",
                                                      $event.target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "option",
                                                  {
                                                    attrs: {
                                                      value: "internal",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$gettext(
                                                          "Interner Link"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "option",
                                                  {
                                                    attrs: {
                                                      value: "external",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$gettext(
                                                          "Externer Link"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        shape.link_type === "internal"
                                          ? _c(
                                              "label",
                                              {
                                                staticClass: "col-2",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      _vm.$gettext(
                                                        "Ziel des Links"
                                                      )
                                                    ) +
                                                    "\n                            "
                                                ),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          shape.target_internal,
                                                        expression:
                                                          "shape.target_internal",
                                                      },
                                                    ],
                                                    on: {
                                                      change: [
                                                        function ($event) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.$set(
                                                            shape,
                                                            "target_internal",
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          )
                                                        },
                                                        _vm.drawScreen,
                                                      ],
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.courseware,
                                                    function (el, index) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: index,
                                                          domProps: {
                                                            value: el.id,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                    " +
                                                              _vm._s(
                                                                el.attributes
                                                                  .title
                                                              ) +
                                                              "\n                                "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        shape.link_type === "external"
                                          ? _c(
                                              "label",
                                              {
                                                staticClass: "col-2",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      _vm.$gettext(
                                                        "Ziel des Links"
                                                      )
                                                    ) +
                                                    "\n                            "
                                                ),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        shape.target_external,
                                                      expression:
                                                        "shape.target_external",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    placeholder:
                                                      "https://www.studip.de",
                                                  },
                                                  domProps: {
                                                    value:
                                                      shape.target_external,
                                                  },
                                                  on: {
                                                    change: function change(
                                                      $event
                                                    ) {
                                                      _vm.drawScreen()
                                                      _vm.fixUrl(index)
                                                    },
                                                    input: function input(
                                                      $event
                                                    ) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        shape,
                                                        "target_external",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("label", [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "button cancel",
                                              on: {
                                                click: function click($event) {
                                                  return _vm.removeShape(index)
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$gettext("Form entfernen")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      2
                                    )
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$gettext(
                          "Informationen zum Verweissensitive-Grafik-Block"
                        )
                      )
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }